"use strict";

jQuery(document).ready(function ($) {
  $('.vacancies__filter').on('click', function () {
    var filter = $(this);
    $('.vacancies__filter').removeClass('active');
    filter.addClass('active');
    var vacancyType = filter.data('filter');
    if (vacancyType === 'all') {
      $('.vacancies__vacancy').removeClass('hide');
    } else {
      $('.vacancies__vacancy').addClass('hide');
      $('.vacancy__type--' + vacancyType).removeClass('hide');
    }
  });
});